/* Clínica Cellus — interacciones del tema */
(function () {
  'use strict';

  /* ---- menú móvil ---- */
  var cab = document.getElementById('cabecera');
  if (cab) {
    var tog = cab.querySelector('.nav-toggle');
    if (tog) {
      tog.addEventListener('click', function () {
        var abierto = cab.classList.toggle('abierto');
        tog.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    }
  }

  /* ---- slider del hero (autoplay + flechas + puntos) ---- */
  document.querySelectorAll('[data-carrusel-hero]').forEach(function (raiz) {
    var pista = raiz.querySelector('[data-pista]');
    var slides = pista ? pista.children : [];
    if (!pista || slides.length < 2) return;

    var i = 0;
    var puntos = raiz.querySelector('[data-puntos]');
    var botones = [];

    function pintar() {
      pista.style.transform = 'translateX(' + (-i * 100) + '%)';
      botones.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    function ir(n) { i = (n + slides.length) % slides.length; pintar(); }

    if (puntos) {
      for (var n = 0; n < slides.length; n++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Ir al slide ' + (idx + 1));
          b.addEventListener('click', function () { ir(idx); reiniciar(); });
          puntos.appendChild(b);
          botones.push(b);
        })(n);
      }
    }

    var prev = raiz.querySelector('[data-prev]');
    var next = raiz.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { ir(i - 1); reiniciar(); });
    if (next) next.addEventListener('click', function () { ir(i + 1); reiniciar(); });

    var timer = null;
    function arrancar() { timer = setInterval(function () { ir(i + 1); }, 6000); }
    function reiniciar() { clearInterval(timer); arrancar(); }
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) arrancar();
    raiz.addEventListener('mouseenter', function () { clearInterval(timer); });
    raiz.addEventListener('mouseleave', arrancar);

    pintar();
  });

  /* ---- carruseles con scroll (especialistas, testimonios, bono PAD) ---- */
  document.querySelectorAll('[data-carrusel]').forEach(function (raiz) {
    var pista = raiz.querySelector('[data-pista]');
    if (!pista) return;

    var prev = raiz.querySelector('[data-prev]');
    var next = raiz.querySelector('[data-next]');
    var ciclico = raiz.hasAttribute('data-ciclico');

    /* Orden distinto en cada visita, para que ningun profesional quede siempre
       primero. Solo lo lleva el carrusel de especialistas; el orden del HTML
       sigue siendo el fijo, que es el que ven Google y los lectores de pantalla
       si el JS no corre. */
    if (raiz.hasAttribute('data-barajar')) {
      var sueltos = Array.prototype.slice.call(pista.children);
      for (var s = sueltos.length - 1; s > 0; s--) {
        var r = Math.floor(Math.random() * (s + 1));
        var tmp = sueltos[s]; sueltos[s] = sueltos[r]; sueltos[r] = tmp;
      }
      var lote = document.createDocumentFragment();
      sueltos.forEach(function (el) { lote.appendChild(el); });
      pista.appendChild(lote);
      /* Mover los hijos deja el scroll al final: sin esto el carrusel arranca
         mostrando las ultimas fichas y con la flecha izquierda como unica salida. */
      pista.scrollTo({ left: 0, behavior: 'instant' });
    }

    function paso() {
      var hijo = pista.firstElementChild;
      if (!hijo) return pista.clientWidth;
      var ancho = hijo.getBoundingClientRect().width + 26;
      var cabe = Math.max(1, Math.floor(pista.clientWidth / ancho));
      return ancho * cabe;
    }
    function alInicio() { return pista.scrollLeft <= 2; }
    function alFinal()  { return pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2; }
    function estado() {
      if (!prev || !next) return;
      /* En el ciclico las flechas nunca se apagan: siempre hay a donde ir. */
      prev.disabled = ciclico ? false : alInicio();
      next.disabled = ciclico ? false : alFinal();
    }
    /* La vuelta al otro extremo es un salto seco y no un barrido: con once
       fichas, recorrerlas todas en pantalla marea y tapa lo que la persona
       queria ver. El avance normal si va suave, como en el resto del sitio. */
    function mover(dir) {
      if (ciclico && dir < 0 && alInicio()) return pista.scrollTo({ left: pista.scrollWidth, behavior: 'instant' });
      if (ciclico && dir > 0 && alFinal())  return pista.scrollTo({ left: 0, behavior: 'instant' });
      pista.scrollBy({ left: dir * paso(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { mover(-1); });
    if (next) next.addEventListener('click', function () { mover(1); });
    pista.addEventListener('scroll', estado, { passive: true });
    window.addEventListener('resize', estado);
    estado();

    /* puntos para carruseles de página completa (bono PAD) */
    var puntos = raiz.querySelector('[data-puntos]');
    var items = pista.children;

    /* Cual de los slides se esta viendo. Se mide por el centro de la pista y no
       por scrollLeft a secas porque estos slides llevan `scroll-snap-align:center`. */
    function indiceActual() {
      var centro = pista.scrollLeft + pista.clientWidth / 2;
      var activo = 0;
      for (var n = 0; n < items.length; n++) {
        if (items[n].offsetLeft - pista.offsetLeft <= centro) activo = n;
      }
      return activo;
    }
    function irASlide(i) {
      if (!items.length) return;
      pista.scrollTo({ left: items[i].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
    }

    if (puntos) {
      for (var n = 0; n < items.length; n++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Ir al banner ' + (idx + 1));
          b.addEventListener('click', function () { irASlide(idx); reiniciarAuto(); });
          puntos.appendChild(b);
        })(n);
      }
      var marcar = function () {
        var activo = indiceActual();
        Array.prototype.forEach.call(puntos.children, function (b, n) {
          b.setAttribute('aria-current', n === activo ? 'true' : 'false');
        });
      };
      pista.addEventListener('scroll', marcar, { passive: true });
      marcar();
    }

    /* ---- rotación automática ----
       La pide el carrusel con `data-auto="<milisegundos>"`. Al llegar al último
       vuelve al primero, así que gira indefinidamente.

       Se detiene mientras la persona está encima, mientras tiene el foco dentro
       o mientras arrastra, y también cuando la pestaña deja de verse: con la
       pestaña oculta el navegador no ejecuta el desplazamiento suave, y los
       turnos se irían acumulando para dispararse de golpe al volver.

       Y no arranca si el sistema pide menos movimiento. */
    var auto = parseInt(raiz.getAttribute('data-auto') || '0', 10);
    var reloj = null;
    function reiniciarAuto() { pararAuto(); arrancarAuto(); }
    function pararAuto() { if (reloj) { clearInterval(reloj); reloj = null; } }
    function arrancarAuto() {
      if (reloj || !(auto >= 1000) || items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      /* A proposito NO se mira `document.hidden` para arrancar, solo para pausar
         cuando llega el evento: hay contextos que se ven en pantalla y aun asi
         lo reportan como oculto, y ahi el carrusel no arrancaria nunca. */
      reloj = setInterval(function () {
        /* `alFinal()` cubre el caso de los carruseles que muestran varias fichas
           a la vez: ahi el ultimo elemento nunca llega al centro, el indice se
           queda corto y sin esto el carrusel se atascaria en la ultima pantalla. */
        if (alFinal()) return irASlide(0);
        var i = indiceActual() + 1;
        if (i >= items.length) i = 0;   // del último, de vuelta al primero
        irASlide(i);
      }, auto);
    }
    if (auto >= 1000) {
      arrancarAuto();
      raiz.addEventListener('mouseenter', pararAuto);
      raiz.addEventListener('mouseleave', arrancarAuto);
      raiz.addEventListener('focusin', pararAuto);
      raiz.addEventListener('focusout', arrancarAuto);
      pista.addEventListener('pointerdown', pararAuto);
      pista.addEventListener('pointerup', reiniciarAuto);
      document.addEventListener('visibilitychange', function () {
        document.hidden ? pararAuto() : arrancarAuto();
      });
    }
  });
})();

/* ---- de dónde vino la visita (atribución) ----
   Hasta el 23-sep el formulario sólo leía las UTM de la página donde se enviaba:
   quien llegaba desde un anuncio a la portada y enviaba en otra página quedaba
   «Orgánico». Ahora, al aterrizar, se guardan en este navegador por 30 días:

     primer   la página de entrada y el sitio que lo trajo (el primer toque)
     campana  la ÚLTIMA visita con marca de campaña (utm_*, gclid, fbclid)

   Se mandan con el lead y nada más: no salen del navegador si la persona no
   envía el formulario. No son datos personales. 30 días es la ventana de clic
   de Google Ads. */
(function () {
  'use strict';
  var CLAVE = 'cellus_atribucion';
  var VIGENCIA = 30 * 24 * 3600 * 1000;
  var ahora = Date.now();

  function leer() {
    try { return JSON.parse(localStorage.getItem(CLAVE) || '{}') || {}; } catch (e) { return {}; }
  }
  function vigente(t) { return t && typeof t.en === 'number' && ahora - t.en < VIGENCIA; }
  function corto(v, max) { return String(v || '').slice(0, max || 300); }

  var guardado = leer();
  var p;
  try { p = new URLSearchParams(location.search); } catch (e) { p = { get: function () { return null; } }; }

  var ref = document.referrer || '';
  var refHost = '';
  try { refHost = ref ? new URL(ref).hostname.replace(/^www\./, '') : ''; } catch (e) {}
  var interna = refHost && refHost === location.hostname.replace(/^www\./, '');

  // Primer toque: sólo al ENTRAR (referrer externo o vacío), nunca al navegar dentro del sitio.
  if (!vigente(guardado.primer) && !interna) {
    guardado.primer = { en: ahora, url: corto(location.href, 500), ref: corto(ref, 300) };
  }

  // Google manda gbraid/wbraid en vez de gclid en algunos clics de iOS: cuentan igual.
  var gclid = p.get('gclid') || p.get('gbraid') || p.get('wbraid') || '';
  var fbclid = p.get('fbclid') || '';
  if (p.get('utm_source') || gclid || fbclid) {
    guardado.campana = {
      en: ahora, url: corto(location.href, 500),
      source: corto(p.get('utm_source'), 120), medium: corto(p.get('utm_medium'), 120),
      campaign: corto(p.get('utm_campaign'), 160), content: corto(p.get('utm_content'), 160),
      term: corto(p.get('utm_term'), 160), gclid: corto(gclid, 200), fbclid: corto(fbclid, 200),
    };
  }

  try { localStorage.setItem(CLAVE, JSON.stringify(guardado)); } catch (e) {}

  /* Lo que viaja con el lead. Vacío si no hay nada vigente. */
  window.cellusAtribucion = function () {
    var g = leer(), d = {};
    ahora = Date.now();
    if (vigente(g.primer)) {
      d.entrada_url = g.primer.url; d.entrada_referrer = g.primer.ref;
      d.entrada_en = new Date(g.primer.en).toISOString();
    }
    if (vigente(g.campana)) {
      var c = g.campana;
      d.campana_source = c.source; d.campana_medium = c.medium; d.campana_campaign = c.campaign;
      d.campana_content = c.content; d.campana_term = c.term;
      d.campana_gclid = c.gclid; d.campana_fbclid = c.fbclid;
      d.campana_url = c.url; d.campana_en = new Date(c.en).toISOString();
    }
    return d;
  };
})();

/* ---- conversiones para Google Ads, GA4 y Meta (23-sep) ----
   El formulario reemplazó al widget de WhatsApp (tochat.be) que tenía el
   WordPress, y las campañas se optimizan con los eventos que disparaba ese
   widget. Por eso el formulario avisa con EL MISMO evento que el widget, y
   GTM-MCH67DXQ hace el resto sin tocar Google Ads, GA4 ni Meta. Con
   dataLayer 'chatwith' el contenedor dispara:

     Google Ads   la conversión del widget (etiqueta S0i_COCzm78aEN3-vsQ-)
     GA4          el evento «form widget whatsapp»
     Meta         el evento «form enviado widget whatsapp», que alimenta la
                  conversión personalizada 551386898010773 de la campaña #06.03

   NO llamar a fbq desde acá: el contenedor ya lo hace, y se contaría doble.
   Sólo el nombre del evento: nada de la consulta ni de la persona, que son
   datos de salud (política de Meta y Ley 21.719). */
window.cellusConversionLead = function () {
  try { (window.dataLayer = window.dataLayer || []).push({ event: 'chatwith' }); } catch (e) {}
};

/* ---- medición del embudo ----
   Un paso por el captador no es un lead: la mayoría no termina en nadie a quien
   llamar. Estos eventos son los que permiten contestar de cien que lo abren,
   cuántos lo completan y cuántos se van por la salida.

   No llevan datos de contacto, nunca. `sendBeacon` primero porque sigue vivo
   aunque la página se esté yendo, que es justo cuando ocurren los pasos más
   interesantes (salida directa, cierre, irse a la agenda). */
window.cellusEvento = function (tipo, extra) {
  try {
    var form = document.querySelector('.lead-form');
    var url = (form && form.dataset.endpoint || '').replace(/\/$/, '');
    if (!url) return;
    var d = extra || {};
    d.tipo = tipo;
    d.pagina = location.pathname;
    var p = new URLSearchParams(location.search);
    d.utm_source = p.get('utm_source') || '';
    d.utm_campaign = p.get('utm_campaign') || '';
    var cuerpo = JSON.stringify(d);
    /* El Blob va como text/plain A PROPOSITO. Con application/json el navegador
       exige un preflight CORS, y sendBeacon no lo hace: devuelve true, la cola
       lo acepta, y el evento nunca llega. Comprobado el 22-sep contra el Worker
       en produccion, con cero eventos registrados y sendBeacon diciendo que si.
       text/plain es un tipo «simple» y sale sin preflight; el Worker lo parsea
       igual, porque `request.json()` no mira el content-type. */
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url + '/evento', new Blob([cuerpo], { type: 'text/plain;charset=UTF-8' }));
    } else {
      fetch(url + '/evento', { method: 'POST', headers: { 'content-type': 'application/json' },
                               body: cuerpo, keepalive: true }).catch(function () {});
    }
  } catch (e) { /* la medición jamás puede romperle nada al paciente */ }
};

/* ---- formulario de leads ----
   Manda el lead al Worker y después abre WhatsApp.
   Si el Worker falla o tarda, abre WhatsApp igual: el contacto nunca se pierde
   por un problema nuestro de infraestructura. */
(function () {
  'use strict';
  document.querySelectorAll('.lead-form').forEach(function (form) {

  var aviso = form.querySelector('.lead-aviso');
  var boton = form.querySelector('.lead-enviar');
  var abierto = Date.now();

  function param(n) {
    try { return new URLSearchParams(location.search).get(n) || ''; } catch (e) { return ''; }
  }

  function respaldoWhatsapp(d) {
    var partes = ['Hola, soy ' + d.nombre + '.'];
    var sel = form.querySelector('[name="unidad"]');
    var txt = sel && sel.selectedIndex > 0 ? sel.options[sel.selectedIndex].text : '';
    if (txt) partes.push('Consulto por: ' + txt + '.');
    if (d.motivo) partes.push(d.motivo);
    return 'https://wa.me/' + form.dataset.whatsapp + '?text=' + encodeURIComponent(partes.join(' '));
  }

  function marcar(campo, mal) {
    if (campo) campo.setAttribute('aria-invalid', mal ? 'true' : 'false');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    aviso.className = 'lead-aviso';
    aviso.textContent = '';

    var d = {};
    ['nombre', 'telefono', 'email', 'unidad', 'prevision', 'motivo', 'empresa']
      .forEach(function (k) {
        var el = form.querySelector('[name="' + k + '"]');
        d[k] = el ? el.value.trim() : '';
      });
    d.consentimiento = form.querySelector('[name="consentimiento"]').checked;

    var aAgenda = form.dataset.destino === 'agenda';

    var falla = null;
    if (!d.unidad) falla = ['unidad', 'Elige el motivo de tu consulta.'];
    else if (aAgenda) falla = null;   // camino a la agenda no se piden datos de contacto
    else if (d.nombre.length < 2) falla = ['nombre', 'Escribe tu nombre.'];
    else if (d.telefono.replace(/\D/g, '').length < 8) falla = ['telefono', 'Revisa tu teléfono.'];
    else if (!d.consentimiento) falla = ['consentimiento', 'Necesitamos tu autorización para contactarte.'];

    ['nombre', 'telefono', 'unidad'].forEach(function (k) { marcar(form.querySelector('[name="' + k + '"]'), false); });
    if (falla) {
      var el = form.querySelector('[name="' + falla[0] + '"]');
      marcar(el, true); if (el) el.focus();
      aviso.className = 'lead-aviso error';
      aviso.textContent = falla[1];
      return;
    }

    d.ms = Date.now() - abierto;
    d.origen_url = location.href;
    /* Desde qué botón o formulario llegó, con la página: columna «Botón de
       origen» de Lead_BOT (27-sep), p. ej. «Botón verde flotante · Rodilla».
       La página sale del título («Rodilla · Clínica Cellus»), sin la bajada
       tras los dos puntos («Hombro: Todo lo que…»). */
    d.boton = (function () {
      var o = form.dataset.origen || '';
      if (!o) return '';
      var pag = location.pathname === '/' ? 'Portada'
        : ((document.title || '').split(' · ')[0].split(':')[0].trim() || location.pathname);
      return o.toLowerCase().indexOf(pag.toLowerCase()) !== -1 ? o : o + ' · ' + pag;
    })();
    d.referrer = document.referrer;
    d.consentimiento_version = form.dataset.consentVersion;
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
      .forEach(function (k) { d[k] = param(k); });
    try {
      var at = window.cellusAtribucion ? window.cellusAtribucion() : {};
      for (var k in at) if (Object.prototype.hasOwnProperty.call(at, k)) d[k] = at[k];
    } catch (e) { /* la atribución jamás puede impedir un envío */ }

    boton.disabled = true;
    aviso.textContent = 'Enviando…';

    /* Camino a la agenda NO se crea un lead: sin telefono no hay a quien llamar
       y la tabla de leads es la bandeja que la clinica trabaja. Se registra la
       intencion —que consulta, su prevision, con quien iba— y se la lleva a la
       agenda. El contacto lo toma AgendaPro. */
    if (aAgenda) {
      var prof = (form.dataset.destinoAgenda || '').match(/profesional=(\d+)/);
      window.cellusEvento('intencion_agenda', {
        destino: 'agenda', unidad: d.unidad, prevision: d.prevision,
        motivo: d.motivo, profesional: prof ? prof[1] : '',
      });
      try { sessionStorage.setItem('cellus_lead_ok', '1'); } catch (e) {}
      aviso.className = 'lead-aviso ok';
      aviso.textContent = 'Listo. Te llevamos a la agenda…';
      form.reset();
      setTimeout(function () {
        location.href = form.dataset.destinoAgenda || form.dataset.agendaUrl || '/pages/reserva-de-horas';
      }, 600);
      return;
    }

    var respaldo = respaldoWhatsapp(d);
    var listo = false;
    var idLead = '';
    /* El formulario se reemplaza por un estado de exito, en vez de limpiarse y
       quedar igual que antes. Las tres razones, medidas el 22-sep en 375px:

         1. `form.reset()` dejaba los campos en blanco y el boton diciendo lo
            mismo: para quien mira la pantalla, eso es identico a que no hubiera
            funcionado. Tres pacientes reenviaron el formulario el mismo dia,
            uno de ellos tres veces en dos minutos.
         2. El aviso iba DEBAJO del boton, asi que caia en 790-836px de una
            pantalla de 812 — fuera de vista. Y en un movil de verdad es peor:
            el teclado ocupa la mitad inferior y tapa justo esa franja.
         3. `window.open` despues de esperar al Worker ya no cuenta como una
            ventana abierta por el usuario, y los moviles la bloquean. El boton
            de aca lo abre con un gesto directo, que no se bloquea nunca.
    */
    function mostrarExito(url, seAbrio) {
      var caja = document.createElement('div');
      caja.className = 'lead-exito';
      caja.setAttribute('role', 'status');
      caja.innerHTML =
        '<p class="le-titulo">Listo, ya tenemos tus datos</p>' +
        '<p class="le-texto">' +
          (seAbrio ? 'Te abrimos WhatsApp en otra pestaña. Si no la ves, entra desde acá.'
                   : 'Te vamos a escribir por WhatsApp. Si prefieres, escríbenos tú ahora:') +
        '</p>';
      var a = document.createElement('a');
      a.className = 'btn btn-amarillo le-wa';
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = 'Abrir WhatsApp';
      a.addEventListener('click', function () {
        window.cellusEvento('whatsapp_abierto', { destino: 'whatsapp', lead_id: idLead });
      });
      caja.appendChild(a);
      form.parentNode.insertBefore(caja, form.nextSibling);
      form.hidden = true;
      /* Instantaneo y no suave: ocultar el formulario acorta la pagina y el
         scroll se reajusta solo, asi que el bloque puede quedar arriba y fuera
         de la vista. Un desplazamiento animado ademas no corre si la pestana
         esta en segundo plano. Lo que importa es que la confirmacion se vea. */
      try { caja.scrollIntoView({ block: 'center', behavior: 'instant' }); } catch (e) {
        try { caja.scrollIntoView(); } catch (e2) {}
      }
      try { a.focus({ preventScroll: true }); } catch (e) {}
    }

    function abrir(url) {
      if (listo) return;
      listo = true;
      try { sessionStorage.setItem('cellus_lead_ok', '1'); } catch (e) {}
      /* Solo la via de WhatsApp llega hasta aca: la de agenda retorna antes. */
      boton.disabled = false;
      form.reset();
      window.cellusEvento('lead_enviado', { destino: 'whatsapp', unidad: d.unidad, lead_id: idLead });
      window.cellusConversionLead();
      var w = null;
      try { w = window.open(url, '_blank', 'noopener'); } catch (e) {}
      if (w) window.cellusEvento('whatsapp_abierto', { destino: 'whatsapp', lead_id: idLead });
      mostrarExito(url, !!w);
    }

    // Si el Worker no contesta en 6 s, seguimos igual por WhatsApp.
    var plazo = setTimeout(function () { abrir(respaldo); }, 6000);

    if (!form.dataset.endpoint) { clearTimeout(plazo); abrir(respaldo); return; }

    fetch(form.dataset.endpoint.replace(/\/$/, '') + '/lead', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(d)
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (j) { clearTimeout(plazo); idLead = (j && j.id) || ''; abrir(j && j.whatsapp ? j.whatsapp : respaldo); })
      .catch(function () { clearTimeout(plazo); abrir(respaldo); });
  });

  });
})();


/* Captador flotante: el botón de abajo a la derecha abre el mismo formulario
   en un panel, en todas las páginas. Antes eso lo hacía el widget de Lycapolis;
   ahora los datos quedan en la base de la clínica. */
(function () {
  'use strict';
  var panel = document.querySelector('[data-captador]');
  if (!panel) return;
  /* Varios disparadores: el boton verde flotante y el telefono de la barra
     superior, que es el mismo numero de WhatsApp. Antes esto tomaba solo el
     primero, asi que un segundo disparador no habria hecho nada. */
  var botones = [].slice.call(document.querySelectorAll('[data-captador-abrir]'));
  var cerrar = panel.querySelector('[data-captador-cerrar]');

  function mostrar(si) {
    panel.classList.toggle('abierto', si);
    botones.forEach(function (b) { b.setAttribute('aria-expanded', si ? 'true' : 'false'); });
    if (si) {
      var primero = panel.querySelector('input,select,textarea');
      if (primero) primero.focus();
    }
  }

  var form = panel.querySelector('.lead-form');
  var titulo = panel.querySelector('[data-captador-titulo]');
  var bajada = panel.querySelector('[data-captador-bajada]');
  var directo = panel.querySelector('[data-captador-directo]');
  var enviar = panel.querySelector('.lead-enviar');

  var TEXTOS = {
    whatsapp: ['Cuéntanos qué te duele',
               'Déjanos tus datos y te escribimos por WhatsApp para coordinar tu evaluación.',
               'Quiero que me contacten', 'Prefiero escribir directo por WhatsApp'],
    agenda:   ['Antes de agendar, cuéntanos de ti',
               'Con estos datos el equipo llega preparado a tu hora. Después te llevamos a la agenda.',
               'Continuar a la agenda', 'Prefiero ir directo a la agenda']
  };

  function configurar(destino) {
    var t = TEXTOS[destino] || TEXTOS.whatsapp;
    if (form) form.dataset.destino = destino;
    /* Camino a la agenda no se piden nombre, telefono ni correo: AgendaPro los
       pide al reservar. Lo que queda es que le duele, su prevision y con quien
       iba, que es lo que hace util el paso sin cobrarle friccion de datos. */
    var aAgenda = destino === 'agenda';
    if (form) {
      form.querySelectorAll('[data-contacto]').forEach(function (el) { el.hidden = aAgenda; });
      var nota = form.querySelector('.lead-nota-agenda');
      if (nota) nota.hidden = !aAgenda;
    }
    if (titulo) titulo.textContent = t[0];
    if (bajada) bajada.textContent = t[1];
    if (enviar) enviar.textContent = t[2];
    if (directo) {
      directo.textContent = t[3];
      directo.href = destino === 'agenda'
        ? (form && (form.dataset.destinoAgenda || form.dataset.agendaUrl)) || '/pages/reserva-de-horas'
        : directo.dataset.whatsapp || directo.href;
      directo.target = destino === 'agenda' ? '_self' : '_blank';
    }
  }

  if (directo) directo.dataset.whatsapp = directo.getAttribute('href');

  botones.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (form) delete form.dataset.destinoAgenda;
      if (form) form.dataset.origen = b.dataset.origen || 'Botón del sitio';
      var dest = b.dataset.destino || 'whatsapp';
      configurar(dest);
      var abriendo = !panel.classList.contains('abierto');
      mostrar(abriendo);
      if (abriendo) window.cellusEvento('captador_abierto', { destino: dest });
    });
  });

  /* Cualquier botón que lleve a la agenda pide los datos primero. Si la persona
     ya los dejó en esta visita, no se le vuelve a preguntar. */
  function yaDejoDatos() {
    try { return sessionStorage.getItem('cellus_lead_ok') === '1'; } catch (e) { return false; }
  }

  var rutaAgenda = (form && form.dataset.agendaUrl) || '/pages/reserva-de-horas';
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || panel.contains(a)) return;
    var destinoUrl = a.getAttribute('href') || '';
    if (destinoUrl.indexOf(rutaAgenda) === -1) return;
    if (yaDejoDatos()) return;
    if (location.pathname.indexOf(rutaAgenda) !== -1) return;
    e.preventDefault();
    if (form) form.dataset.destinoAgenda = destinoUrl;
    if (form) form.dataset.origen = 'Agendar';
    configurar('agenda');
    var _prof = destinoUrl.match(/profesional=(\d+)/);
    window.cellusEvento('captador_abierto', { destino: 'agenda', profesional: _prof ? _prof[1] : '' });
    /* Si el enlace nombra a un medico (fichas de especialistas), se prellena el
       motivo: la ejecutiva ve con quien queria la hora, y la persona lo puede
       editar antes de enviar. */
    var prof = a.getAttribute('data-profesional');
    if (prof && form) {
      var campoMotivo = form.querySelector('[name="motivo"]');
      if (campoMotivo && !campoMotivo.value) campoMotivo.value = 'Quiero agendar con ' + prof;
    }
    mostrar(true);
  }, true);
  function cerrarPanel() {
    if (!panel.classList.contains('abierto')) return;
    window.cellusEvento('captador_cerrado', { destino: form ? form.dataset.destino : '' });
    mostrar(false);
  }
  if (cerrar) cerrar.addEventListener('click', cerrarPanel);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarPanel();
  });
  /* «Prefiero ir directo»: el paso que mas interesa medir, porque es el que
     dice cuanta gente considera el formulario un peaje. */
  if (directo) directo.addEventListener('click', function () {
    window.cellusEvento('salida_directa', { destino: form ? form.dataset.destino : '' });
  });
})();


/* ---- la agenda de un profesional en concreto ----
   Los botones «Agendar consulta» del carrusel de la portada llevan a la página
   de reserva con `?profesional=<id>`, el id de AgendaPro. Van por la página del
   sitio y no directo a agendapro.com para que el captador los intercepte y pida
   los datos antes, que es el diseño de todo el sitio.

   Solo se acepta un id de dígitos y la URL se arma acá con la base del tema:
   si llegara una dirección completa por el parámetro, no se usa. */
(function () {
  'use strict';
  var marco = document.querySelector('.agenda-marco iframe');
  if (!marco) return;
  var id = (new URLSearchParams(location.search).get('profesional') || '').trim();
  if (!/^\d{1,12}$/.test(id)) return;
  var base = marco.getAttribute('src') || '';
  if (!base) return;
  marco.setAttribute('src', base.replace(/\/+$/, '') + '/profesional/' + id);
})();


/* Cierra el embudo: cuantos llegan de verdad a la agenda. Va aparte del bloque
   de arriba porque interesa tambien cuando no se pidio un profesional. */
(function () {
  'use strict';
  if (!document.querySelector('.agenda-marco iframe')) return;
  var id = (new URLSearchParams(location.search).get('profesional') || '').trim();
  if (window.cellusEvento) {
    window.cellusEvento('agenda_vista', { destino: 'agenda', profesional: /^\d{1,12}$/.test(id) ? id : '' });
  }
  /* Para GTM (27-sep). En el WordPress el botón «RESERVA TU HORA» era un enlace
     a AgendaPro y GTM-MCH67DXQ contaba ese clic (Google Ads «Click Botón
     AgendaPRO» HjlUCNOJ2_YbEN3-vsQ-, GA4 «Click boton agenda», Meta «Click en
     agendamiento»). Acá la agenda va incrustada después del captador y no hay
     enlace que clicar, así que el equivalente es llegar a la agenda. Este aviso
     no dispara nada hasta que en GTM se le agregue el activador «Evento
     personalizado = agenda_abierta» a esas tres etiquetas (la cuenta de Cellus
     no tiene acceso al contenedor). La reserva en sí la mide AgendaPro dentro
     del iframe, con el píxel y el GA4 de la clínica. Sin datos de la persona. */
  try { (window.dataLayer = window.dataLayer || []).push({ event: 'agenda_abierta' }); } catch (e) {}
})();
